import React from 'react';
import { Modal } from 'react-bootstrap';
import { CloseIcon, QouteStart, ColoredChatIcon, QouteEnd } from 'ui-component/custom-icons/icons'


// ✅ Clear
const PaymentCommentModal = ({ openPopup, details, onHandleReloadData, handleClose }) => {
    
    return (
        <Modal show={openPopup}  centered size="sm">
            <Modal.Body>
                <div className="p-2">
                    <div style={{ padding: '20px' }}>
                        <div className="mb-2 ml-0 pl-0">

                            <div className="row">
                                <div className="col-12 text-center">
                                    <ColoredChatIcon height={'60px'} width={'60px'} />
                                </div>
                            </div>
                            <button className="btn modal-close-icon" onClick={handleClose}>
                                <CloseIcon height={'16px'} width={'16px'} />
                            </button>
                        </div>

                        <div className="row align-items-top">
                            <div className="col-12 text-center " style={{ padding: '10px 0 10px 0' }}>
                                <div style={{ fontSize: '24px' }}>
                                    Payment Note
                                </div>
                                
                            </div>
                        </div>
                        <div className="row align-items-top">
                            <div className="col-12 text-left textGray font18" style={{ padding: '10px 0' }}>
                                <div >
                                    <span className="mt-10 textGray">
                                        <QouteStart width='18px' height='18px' />
                                    </span>
                                        <span
                                            className=" font18"
                                            dangerouslySetInnerHTML={{
                                                __html: details?.note
                                            }}
                                        />
                                    <span className="mt-10 textGray">
                                        <QouteEnd width='18px' height='18px' />
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PaymentCommentModal;
